<div class="input-wrapper" [ngClass]="{ error: errorMessage }">
  <label>
    {{ label }}
    <span *ngIf="errorMessage"> {{ label ? '-' : '' }} *{{ errorMessage }}</span>
  </label>
  <input *ngIf="!isTextarea" [value]="value" [type]="type" [placeholder]="placeholder" />
  <textarea *ngIf="isTextarea" [value]="value" [placeholder]="placeholder"></textarea>
</div>
